import React, { useState } from "react";

import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";

import _ from "lodash";

import { useQuery } from "@apollo/react-hooks";
import { loader } from "graphql.macro";

const PROVINCES = loader("./graphql/ProvinceList.gql");

export default (props) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const { loading } = useQuery(PROVINCES, {
    variables: {
      order_by: [{ province_name: "asc" }],
    },
    onCompleted(data) {
      setOptions(_.get(data, "provinces") || []);
    },
  });

  return (
    <Autocomplete
      {...props}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      options={options.sort(
        (a, b) =>
          -b.province_name[0]
            .toUpperCase()
            .localeCompare(a.province_name[0].toUpperCase())
      )}
      groupBy={(option) => option.province_name[0].toUpperCase()}
      getOptionSelected={(option, value) => {
        return option.province_code === value.province_code;
      }}
      getOptionLabel={(option) => {
        return option.province_name;
      }}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="จังหวัด"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};
